import * as Tooltip from '@radix-ui/react-tooltip';
import { forwardRef, type ComponentPropsWithoutRef, type ElementRef, type ReactNode } from 'react';
import { cn } from '../../lib/cn';

export const TooltipProvider = Tooltip.Provider;

interface QuickTipProps {
  content: ReactNode;
  children: ReactNode;
  side?: 'top' | 'bottom' | 'left' | 'right';
  className?: string;
}

export function QuickTip({ content, children, side = 'top', className }: QuickTipProps) {
  return (
    <Tooltip.Root delayDuration={300}>
      <Tooltip.Trigger asChild>{children}</Tooltip.Trigger>
      <TooltipContent side={side} className={className}>
        {content}
      </TooltipContent>
    </Tooltip.Root>
  );
}

export const TooltipContent = forwardRef<
  ElementRef<typeof Tooltip.Content>,
  ComponentPropsWithoutRef<typeof Tooltip.Content>
>(({ className, sideOffset = 6, ...props }, ref) => (
  <Tooltip.Portal>
    <Tooltip.Content
      ref={ref}
      sideOffset={sideOffset}
      className={cn(
        'z-50 max-w-xs rounded-md bg-zinc-900 px-2.5 py-1.5 text-[11.5px] font-medium text-white shadow-soft',
        'data-[state=delayed-open]:animate-fade-in',
        className,
      )}
      {...props}
    />
  </Tooltip.Portal>
));
TooltipContent.displayName = 'TooltipContent';
